/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Form } from 'antd';
import { Input } from 'components/gyramais';

const { Item } = Form;

const BadesulInput = ({ input, loading, postalCodeToAddress, sizeMap }) => (
  <Col {...sizeMap[input.size]}>
    <Item
      name={input.value}
      rules={
        input.notRequired
          ? []
          : [
              {
                required: true,
                message: `Por favor preencha o campo ${input.name.toLowerCase()}.`,
              },
            ]
      }
      label={input.name}
    >
      <Input
        loading={loading}
        type={input.maskType ? 'masked' : input.type}
        disabled={input.disabled}
        className="ant-input"
        guide
        mask={input.maskType}
        placeholder={input.name}
        onKeyUp={(e) => {
          if (input.value === 'address_postalCode') {
            const postalCode = e.target.value.replace(/[_-\s]/g, '');
            if (postalCode.replace(/[_-\s]/g, '').length === 8 && !loading) {
              postalCodeToAddress({ variables: { postalCode } });
            }
          }
        }}
      />
    </Item>
  </Col>
);

export default BadesulInput;
